module.exports = __webpack_public_path__ + "img/brand-10.f46be59f.svg";